function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { redirectTo } from '../hooks/useRedirect';
import { alertConstants } from '../redux/constants';
import { CLEAR_PENDING_REQUESTS, REMOVE_FROM_PENDING_REQUESTS, SET_PENDING_REQUESTS } from '../redux/constants/api';
import { clearUser, getUser } from './storage';
export var stripePromise = process.env.DISABLE_STRIPE ? null : loadStripe(process.env.STRIPE_PUBLISHABLE_KEY);
export var larkiApiNoAuthentication = axios.create({
    baseURL: process.env.LARKI_API_URL + '/api',
    headers: {
        'Content-Type': 'application/json'
    },
    transformRequest: [
        function(data, headers) {
            if (process.env.BUILD_NUMBER) {
                headers['Larki-Version'] = process.env.BUILD_NUMBER;
            }
            return data;
        }
    ].concat(_to_consumable_array(axios.defaults.transformRequest))
});
export var larkiApi = axios.create({
    baseURL: process.env.LARKI_API_URL + '/api',
    headers: {
        'Content-Type': 'application/json'
    },
    transformRequest: [
        function(data, headers) {
            var sessionToken;
            try {
                sessionToken = getUser().token;
            } catch (err) {
                sessionToken = '<not logged in>'; // trigger usual unauthenticated error path
            }
            headers['Authorization'] = 'Bearer ' + sessionToken;
            if (process.env.BUILD_NUMBER) {
                headers['Larki-Version'] = process.env.BUILD_NUMBER;
            }
            return data;
        }
    ].concat(_to_consumable_array(axios.defaults.transformRequest))
});
export var setupInterceptors = function(param) {
    var dispatch = param.dispatch;
    larkiApi.interceptors.request.use(function(config) {
        config.requestId = uuidv4();
        dispatch({
            type: SET_PENDING_REQUESTS,
            payload: {
                url: config.url,
                id: config.requestId
            }
        });
        return config;
    });
    larkiApi.interceptors.response.use(function(response) {
        if (response.headers['larki-version-outdated'] === 'true') {
            dispatch({
                type: alertConstants.ALERT_VERSION_OUTDATED
            });
        }
        dispatch({
            type: REMOVE_FROM_PENDING_REQUESTS,
            payload: response.config.requestId
        });
        return response;
    }, function(error) {
        var _error_response;
        if (((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 401) {
            /**
         * 401 error is triggered when the user is not logged in
         * we need to clear the user and redirect to the login page
         * but only if the user is not anonymous
         */ var user = getUser();
            if (!user.is_anonymous) {
                clearUser();
            }
            redirectTo("".concat(process.env.LARKI_APP_URL, "/login").concat(history.location.search));
        } else {
            var _error_config, _error_config1;
            var dispatchType = ((_error_config = error.config) === null || _error_config === void 0 ? void 0 : _error_config.requestId) ? REMOVE_FROM_PENDING_REQUESTS : CLEAR_PENDING_REQUESTS;
            dispatch({
                type: dispatchType,
                payload: ((_error_config1 = error.config) === null || _error_config1 === void 0 ? void 0 : _error_config1.requestId) || null
            });
            throw error;
        }
    });
};
export var client = {
    // Projects
    listProjects: /*#__PURE__*/ _async_to_generator(function() {
        var _ref, isAdmin, status, inviteStatus, includeDemo;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            _ref = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {}, isAdmin = _ref.isAdmin, status = _ref.status, inviteStatus = _ref.inviteStatus, includeDemo = _ref.includeDemo;
            return [
                2,
                larkiApi.get('/project', {
                    params: {
                        isAdmin: isAdmin,
                        status: status,
                        inviteStatus: inviteStatus,
                        includeDemo: includeDemo
                    }
                })
            ];
        });
    }),
    getLatestProject: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(param) {
            var isAdmin, inviteStatus, includeDemo, includeJobs, includePointCloud;
            return _ts_generator(this, function(_state) {
                isAdmin = param.isAdmin, inviteStatus = param.inviteStatus, includeDemo = param.includeDemo, includeJobs = param.includeJobs, includePointCloud = param.includePointCloud;
                return [
                    2,
                    larkiApi.get('/project/latest', {
                        params: {
                            isAdmin: isAdmin,
                            inviteStatus: inviteStatus,
                            includeDemo: includeDemo,
                            includeJobs: includeJobs,
                            includePointCloud: includePointCloud
                        }
                    })
                ];
            });
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(),
    listProjectActivities: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, query) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get("/project/".concat(projectId, "/activities"), {
                        params: {
                            query: query
                        }
                    })
                ];
            });
        });
        return function(projectId, query) {
            return _ref.apply(this, arguments);
        };
    }(),
    inviteUserToProject: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, email) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.post("/project/".concat(projectId, "/user"), {
                        email: email
                    })
                ];
            });
        });
        return function(projectId, email) {
            return _ref.apply(this, arguments);
        };
    }(),
    getProjectById: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, param) {
            var includeJobs, includePointCloud, _param_includeQuote, includeQuote;
            return _ts_generator(this, function(_state) {
                includeJobs = param.includeJobs, includePointCloud = param.includePointCloud, _param_includeQuote = param.includeQuote, includeQuote = _param_includeQuote === void 0 ? false : _param_includeQuote;
                return [
                    2,
                    larkiApi.get("/project/".concat(projectId), {
                        params: {
                            includeJobs: includeJobs,
                            includePointCloud: includePointCloud,
                            includeQuote: includeQuote
                        }
                    })
                ];
            });
        });
        return function(projectId, _) {
            return _ref.apply(this, arguments);
        };
    }(),
    createProject: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(name) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.post('/project', {
                        name: name
                    })
                ];
            });
        });
        return function(name) {
            return _ref.apply(this, arguments);
        };
    }(),
    removeUserFromProject: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, email) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.delete("/project/".concat(projectId, "/user"), {
                        data: {
                            email: email
                        }
                    })
                ];
            });
        });
        return function(projectId, email) {
            return _ref.apply(this, arguments);
        };
    }(),
    listProjectUsers: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get("/project/".concat(projectId, "/users"))
                ];
            });
        });
        return function(projectId) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateProjectName: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, name) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            larkiApi.put("/project/".concat(projectId, "/name"), {
                                name: name
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        });
        return function(projectId, name) {
            return _ref.apply(this, arguments);
        };
    }(),
    registerProjectTrialMembers: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, users) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.post("/project/".concat(projectId, "/user/register-trial"), {
                        users: users
                    })
                ];
            });
        });
        return function(projectId, users) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateUserProjectTrial: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, userId, newProjectRole) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.put("/project/".concat(projectId, "/user/").concat(userId, "/project-trial"), {
                        projectRole: newProjectRole
                    })
                ];
            });
        });
        return function(projectId, userId, newProjectRole) {
            return _ref.apply(this, arguments);
        };
    }(),
    mergeProjects: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, targetProjectId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.post("/project/".concat(projectId, "/merge"), {
                        targetProjectId: targetProjectId
                    })
                ];
            });
        });
        return function(projectId, targetProjectId) {
            return _ref.apply(this, arguments);
        };
    }(),
    generateDownloadAllUrl: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get("/project/".concat(projectId, "/asset/download-url"))
                ];
            });
        });
        return function(projectId) {
            return _ref.apply(this, arguments);
        };
    }(),
    getDownloadAllUrl: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, jobId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get("/project/".concat(projectId, "/asset/download-url/poll/").concat(jobId))
                ];
            });
        });
        return function(projectId, jobId) {
            return _ref.apply(this, arguments);
        };
    }(),
    toResumeDownload: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get("/project/".concat(projectId, "/asset/to-resume-download"))
                ];
            });
        });
        return function(projectId) {
            return _ref.apply(this, arguments);
        };
    }(),
    // Job
    getJobById: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(jobId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get("/job/".concat(jobId))
                ];
            });
        });
        return function(jobId) {
            return _ref.apply(this, arguments);
        };
    }(),
    updateJobDetailedStatus: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(jobId, detailedStatus, sendNotification) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.put("/job/".concat(jobId, "/detailed-status"), {
                        detailedStatus: detailedStatus,
                        sendNotification: sendNotification
                    })
                ];
            });
        });
        return function(jobId, detailedStatus, sendNotification) {
            return _ref.apply(this, arguments);
        };
    }(),
    getJobAsset: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, assetId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get("/project/".concat(projectId, "/asset/").concat(assetId, "/download-url"))
                ];
            });
        });
        return function(projectId, assetId) {
            return _ref.apply(this, arguments);
        };
    }(),
    createActivity: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, activity) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.post("/project/".concat(projectId, "/activity"), _object_spread({}, activity))
                ];
            });
        });
        return function(projectId, activity) {
            return _ref.apply(this, arguments);
        };
    }(),
    updatePointerraId: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(projectId, pointerraId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.put("/project/".concat(projectId, "/pointerra"), {
                        pointerraId: pointerraId
                    })
                ];
            });
        });
        return function(projectId, pointerraId) {
            return _ref.apply(this, arguments);
        };
    }(),
    // User
    onboardUser: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(param, coupon) {
            var fullName, phoneNumber, profession, isMarketingEnabled;
            return _ts_generator(this, function(_state) {
                fullName = param.fullName, phoneNumber = param.phoneNumber, profession = param.profession, isMarketingEnabled = param.isMarketingEnabled;
                return [
                    2,
                    larkiApi.post('/user/onboarding', {
                        full_name: fullName,
                        phone_number: phoneNumber,
                        profession: profession,
                        is_marketing_enabled: isMarketingEnabled
                    }, {
                        params: {
                            coupon: coupon
                        }
                    })
                ];
            });
        });
        return function(_, coupon) {
            return _ref.apply(this, arguments);
        };
    }(),
    listUserCards: /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                larkiApi.get('user/cards')
            ];
        });
    }),
    createDiscountCode: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(discountCode) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.post('/user/discount-code', {
                        discountCode: discountCode
                    })
                ];
            });
        });
        return function(discountCode) {
            return _ref.apply(this, arguments);
        };
    }(),
    checkout: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(jobId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.post("/job/".concat(jobId, "/checkout"))
                ];
            });
        });
        return function(jobId) {
            return _ref.apply(this, arguments);
        };
    }(),
    removeCard: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(paymentMethodId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.delete("/user/payment-method", {
                        params: {
                            paymentMethodId: paymentMethodId
                        }
                    })
                ];
            });
        });
        return function(paymentMethodId) {
            return _ref.apply(this, arguments);
        };
    }(),
    createPaymentMethodSetup: /*#__PURE__*/ _async_to_generator(function() {
        return _ts_generator(this, function(_state) {
            return [
                2,
                larkiApi.post("/user/payment-method-setup")
            ];
        });
    }),
    getJobReceipt: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(jobId, paymentIntentId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get("/job/".concat(jobId, "/receipt"), {
                        params: {
                            paymentIntentId: paymentIntentId
                        }
                    })
                ];
            });
        });
        return function(jobId, paymentIntentId) {
            return _ref.apply(this, arguments);
        };
    }(),
    getMembershipReceipt: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(paymentIntentId) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get('/user/membership/receipt', {
                        params: {
                            paymentIntentId: paymentIntentId
                        }
                    })
                ];
            });
        });
        return function(paymentIntentId) {
            return _ref.apply(this, arguments);
        };
    }(),
    copyJob: function(jobId) {
        return larkiApi.post("/job/".concat(jobId, "/copy"));
    },
    deleteActivity: function(projectId, activityId) {
        return larkiApi.delete("/project/".concat(projectId, "/activity/").concat(activityId));
    },
    deleteAsset: function(jobId, assetId) {
        return larkiApi.delete("/job/".concat(jobId, "/asset/").concat(assetId));
    },
    getSmartSelections: function(place) {
        return larkiApi.post("/engine/product/selections", place);
    },
    getSelectionFeaturesFile: function(jobId, selections, fileType) {
        return larkiApi.post("/job/".concat(jobId, "/selections/download-url"), {
            selections: selections,
            fileType: fileType
        });
    },
    getTrialMembershipDetails: function() {
        return larkiApi.get('/user/membership/trial-details');
    },
    createMembership: function(priceId, paymentMethodId, isTrial) {
        return larkiApi.post('/user/membership', {
            priceId: priceId,
            paymentMethodId: paymentMethodId,
            isTrial: isTrial
        });
    },
    updateMembership: function(priceId, paymentMethodId) {
        return larkiApi.put('/user/membership', {
            priceId: priceId,
            paymentMethodId: paymentMethodId
        });
    },
    cancelMembership: function(subscriptionId) {
        return larkiApi.delete("/user/membership/".concat(subscriptionId));
    },
    refreshCustomer: function() {
        return larkiApi.put('/user/customer-refresh');
    },
    sendQuote: function(priceId, email, name, message, jobId) {
        return larkiApi.post('/user/send-quote', {
            priceId: priceId,
            name: name,
            email: email,
            jobId: jobId,
            message: message
        });
    },
    acceptQuote: function(quoteId, token) {
        return larkiApi.post("/user/accept-quote/".concat(quoteId, "?token=").concat(token));
    },
    getUserMembership: function() {
        return larkiApi.get('/user/membership');
    },
    giveUserTrial: function(userId, param) {
        var priceId = param.priceId, paymentMethodId = param.paymentMethodId, days = param.days;
        return larkiApi.post("/user/give-trial/".concat(userId), {
            priceId: priceId,
            paymentMethodId: paymentMethodId,
            days: days
        });
    },
    createProjectAsset: function(projectId, filename, contentType) {
        return larkiApi.post("/project/".concat(projectId, "/asset"), {
            filename: filename,
            contentType: contentType
        });
    },
    commitProjectAsset: function(projectId, assetId) {
        return larkiApi.put("/project/".concat(projectId, "/asset/").concat(assetId, "/commit"));
    },
    updateLotAreaState: function(jobId, lotAreaState) {
        return larkiApi.put("/job/".concat(jobId, "/lot-area-state"), lotAreaState);
    },
    sendLead: function(jobId, type) {
        return larkiApi.post("/job/".concat(jobId, "/lead"), {
            type: type
        });
    },
    createLeadWithoutJob: function(type) {
        return larkiApi.post("/lead/create-without-job", {
            type: type
        });
    },
    updateUserProjectVisibility: function(projectId, userId, visibility) {
        return larkiApi.put("/project/".concat(projectId, "/user-visibility"), {
            visibility: visibility,
            userId: userId
        });
    },
    createBookmark: function(projectId, redirectUrl, metadata) {
        return larkiApi.post("/project/bookmark/".concat(projectId), {
            redirect_url: redirectUrl,
            metadata: metadata
        });
    },
    requestAccess: function(shareToken) {
        return larkiApi.post("/project/bookmark/".concat(shareToken, "/request"));
    },
    listRequestAccess: function(projectId) {
        return larkiApi.get("/project/".concat(projectId, "/request-access"));
    },
    getRequestAccessCount: function(projectId) {
        return larkiApi.get("/project/".concat(projectId, "/request-access/count"));
    },
    updateRequestAccess: function(projectId, userId, status) {
        return larkiApi.put("/project/".concat(projectId, "/request-access"), {
            user_id: userId,
            status: status
        });
    },
    openBookmark: function(shareToken) {
        return larkiApi.get("/ln/".concat(shareToken));
    },
    updateBookmarkRequest: function(bookmarkId, data) {
        return larkiApi.put("/project/".concat(bookmarkId, "/update-bookmark-request"), data);
    },
    generateOtp: function() {
        return larkiApi.post('/user/otp');
    },
    verifyOtp: function(otp) {
        return larkiApi.post("/user/otp/verify/".concat(otp));
    },
    getInvoiceBySubscriptionId: function(subscriptionId) {
        return larkiApi.get("/job/".concat(subscriptionId, "/invoice"));
    },
    generateInvoice: function(jobId, email, name, message) {
        var shouldCreateActivity = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, shouldCommitOrder = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        return larkiApi.post("/job/".concat(jobId, "/order/invoice"), {
            email: email,
            name: name,
            message: message,
            shouldCreateActivity: shouldCreateActivity,
            shouldCommitOrder: shouldCommitOrder
        });
    },
    payInvoice: function(invoiceId) {
        return larkiApi.post("/job/invoice/".concat(invoiceId, "/pay"));
    }
};
export var eventClient = {
    createPointerraEvent: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(type, point_cloud_id, detail) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.post('/event/pointerra', {
                        type: type,
                        point_cloud_id: point_cloud_id,
                        detail: detail
                    })
                ];
            });
        });
        return function(type, point_cloud_id, detail) {
            return _ref.apply(this, arguments);
        };
    }()
};
export var tourApi = {
    getTourStatus: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(modalName) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.get("/user/tour-status/".concat(modalName))
                ];
            });
        });
        return function(modalName) {
            return _ref.apply(this, arguments);
        };
    }(),
    putTourStatus: /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(modalname) {
            return _ts_generator(this, function(_state) {
                return [
                    2,
                    larkiApi.put("/user/tour-status/".concat(modalname))
                ];
            });
        });
        return function(modalname) {
            return _ref.apply(this, arguments);
        };
    }()
};
export var quoteOrderRoute = function() {
    var jobId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return {
        url: "/job/".concat(jobId, "/order/quote"),
        pattern: /^\/job\/\d+\/order\/quote$/
    };
};
